import Cookies from 'js-cookie'

export enum TrackingEvent {
    BigformActioned = 'Bigform Actioned',
    DemoBookingActioned = 'Commercial Page Book Demo Actioned',
    ReCaptchaActioned = 'reCAPTCHA Actioned',
    EmailSignupActioned = 'Email Signup Actioned',
    CookiePreferencesActioned = 'Cookie Preferences Actioned',
    CookieBannerActioned = 'Cookie Banner Actioned',
    HomepageSectionActioned = 'Homepage Actioned',
    ERGActioned = 'ERG Actioned',
    ROICActioned = 'ROIC Actioned',
    EPBActioned = 'EPB Actioned',
    PlanSelected = 'Plan selected',
    InvoiceSubscribeActioned = 'Invoice Subscribe Actioned',
    SignupActioned = 'Performance Marketing - Signup Actioned',
    PreLaunchEmailSignupActioned = 'Pre Launch Email Signup Actioned',
    PreLaunchFormActioned = 'Pre Launch Form Actioned',
    ForwardSignupViewed = 'Forward Signup Viewed',
    PodcastFormActioned = 'Podcast Form Actioned',
    SliderCardsButtonActioned = 'SliderCards Button Actioned',
    PageTranslated = 'Page Translated',

    BigformViewed = 'Bigform Viewed', // temp fix
    BigformSubmitted = 'Bigform Submitted', // temp fix
    DemoBookingViewed = 'Demo Booking Viewed', // temp fix
    DemoBookingSubmitted = 'Demo Booking Submitted', // temp fix

    NotificationBannerActioned = 'Notification Banner Actioned',

    // Blog events
    NewsletterSignUpFormActioned = 'Newsletter signup form submitted',

    FlexsBenefitsSliderActioned = 'Flex Benefits Slider Actioned',
    FlexBenefitsLocationChange = 'Flex Benefits Location Changed',
    FlexBenefitsOfficeChange = 'Flex Benefits Office Changed',
    FlexBenefitsBaseBenefitsViewed = 'Flex Benefits Base Benefits Viewed',
    FlexBenefitsOpenRolesLinkActioned = 'Flex Benefits Open Roles Link Actioned ',

    PricingBillingCycleActioned = 'Pricing Billing Cycle Actioned',
    PricingAdditionalUsersModalOpened = 'Pricing Additional User Modal Opened',
}

type EventData =
    | [TrackingEvent.BigformActioned, {action: 'started' | 'completed'}]
    | [TrackingEvent.BigformActioned, {action: 'interacted'; field: string}]
    | [TrackingEvent.DemoBookingActioned, {action: 'started' | 'completed' | 'clicked'}]
    | [TrackingEvent.ReCaptchaActioned, {action: 'started' | 'completed'}]
    | [
          TrackingEvent.EmailSignupActioned,
          {action: 'submitted' | 'blocked'; form: string; email: string}
      ]
    | [TrackingEvent.CookiePreferencesActioned, {action: 'opened' | 'closed'}]
    | [TrackingEvent.CookiePreferencesActioned, {action: 'saved'; cookiesAllowed: boolean}]
    | [TrackingEvent.CookieBannerActioned, {action: 'shown' | 'dismissed' | 'opened'}]
    | [
          TrackingEvent.HomepageSectionActioned,
          (
              | {
                    action: 'section_viewed'
                    section:
                        | 'feature_blocks_section'
                        | 'video_tabs_section'
                        | 'card_carousel_section'
                        | 'trust_points_section'
                        | 'statistics_section'
                        | 'testimonials_section'
                        | 'logos_grid_section'
                        | 'signup_banner_section'
                    sub_section?: string
                }
              | {
                    action: 'manage_bills_view_toggled'
                    view: string
                }
              | {
                    action:
                        | 'integrations_cta_clicked'
                        | 'card_carousel_interacted'
                        | 'video_tabs_interacted'
                        | 'testimonials_interacted'
                        | 'customers_link_clicked'
                        | 'hero_video_clicked'
                }
          )
      ]
    | [TrackingEvent.BigformViewed] // temp fix
    | [TrackingEvent.BigformSubmitted, {}] // temp fix
    | [TrackingEvent.DemoBookingViewed] // temp fix
    | [TrackingEvent.DemoBookingSubmitted] // temp fix
    | [
          TrackingEvent.ERGActioned,
          {
              action:
                  | 'first_interaction'
                  | 'expense_added'
                  | 'expense_deleted'
                  | 'preview_opened'
                  | 'pdf_generated'
                  | 'pdf_downloaded'
                  | 'pdf_shared'
                  | 'almost_there_step_reached'
                  | 'success_step_reached'
              variant: 'external' | 'internal'
          }
      ]
    | [
          TrackingEvent.ROICActioned,
          {
              action: 'pdf_downloaded' | 'pdf_generated'
          }
      ]
    | [
          TrackingEvent.EPBActioned,
          {
              action: 'pdf_downloaded' | 'pdf_generated'
          }
      ]
    | [
          TrackingEvent.PlanSelected,
          {
              value: 'starter' | 'essential' | 'advanced'
          }
      ]
    | [
          TrackingEvent.InvoiceSubscribeActioned,
          {
              action: 'subscribed'
              email: string
          }
      ]
    | [
          TrackingEvent.NewsletterSignUpFormActioned,
          {
              action: 'submitted' | 'blocked'
              email: string
          }
      ]
    | [TrackingEvent.SignupActioned, {action: 'started'; value: 1}]
    | [TrackingEvent.ForwardSignupViewed]
    | [
          TrackingEvent.PodcastFormActioned,
          {
              action: 'submitted'
              email: string
          }
      ]
    | [
          TrackingEvent.PreLaunchFormActioned,
          {
              action: 'submitted'
              email: string
          }
      ]
    | [
          TrackingEvent.PreLaunchFormActioned,
          {
              action: 'interacted'
              field: string
          }
      ]
    | [
          TrackingEvent.PreLaunchEmailSignupActioned,
          {action: 'submitted' | 'blocked'; form: string; email: string}
      ]
    | [TrackingEvent.PreLaunchEmailSignupActioned, {action: 'interacted'; form: string}]
    | [TrackingEvent.SliderCardsButtonActioned, {action: 'clicked'}]
    | [TrackingEvent.NotificationBannerActioned, {action: 'clicked'}]
    | [TrackingEvent.FlexsBenefitsSliderActioned, {action: 'interacted'; slider: string}]
    | [TrackingEvent.FlexBenefitsLocationChange, {action: 'changed'; location: string}]
    | [TrackingEvent.FlexBenefitsOfficeChange, {action: 'changed'; office: string}]
    | [TrackingEvent.FlexBenefitsBaseBenefitsViewed]
    | [TrackingEvent.FlexBenefitsOpenRolesLinkActioned, {action: 'completed'}]
    | [TrackingEvent.PageTranslated, {action: 'page_translated'; language: string; path: string}]
    | [
          TrackingEvent.PricingBillingCycleActioned,
          {action: 'changed'; selected: 'monthly' | 'yearly'}
      ]
    | [TrackingEvent.PricingAdditionalUsersModalOpened, {action: 'opened'}]

export const track = (...eventData: EventData) => {
    window.analytics?.ready(() => {
        const user = window.analytics?.user?.()

        // We type cast because the types package does not correctly represent the return type of this method
        // docs for correct return type are here:
        // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/identity/#user-and-group-information
        const traits = (user?.traits?.() as SegmentContext['traits']) || {}

        window.analytics?.track(
            eventData[0],
            {
                ...eventData[1],
                path: window.location.pathname.split('/').slice(2).join('/'),
                locale: window.location.pathname.split('/')[1],
                origin: window.location.origin,
            },
            {
                context: {
                    traits: {
                        ...traits,
                        externalId: traits?.externalId || traits?.external_id,
                        facebookClickId: Cookies.get('_fbc'),
                    },
                },
            }
        )
    })
}

// Definition for type: https://segment.com/docs/connections/spec/common/#context, not in types package
export type SegmentContext = {
    active?: boolean
    app?: {
        name: string
        version: string
        build: string
    }
    campaign?: {
        name: string
        source: string
        medium: string
        term: string
        content: string
        [key: string]: any
    }
    device?: {
        id: string
        advertisingId: string
        manufacturer: string
        model: string
        name: string
        type: string
        version: string
    }
    ip?: string
    library?: {
        name: string
        version: string
    }
    locale?: string
    location?: {
        city: string
        country: string
        latitude: string
        longitude: string
        region: string
        speed: string
    }
    network?: {
        bluetooth: string
        carrier: string
        cellular: string
        wifi: string
    }
    os?: {
        name: string
        version: string
    }
    page?: {
        path: string
        referrer: string
        search: string
        title: string
        url: string
    }
    referrer?: {
        type: string
        name: string
        url: string
        link: string
    }
    screen?: {
        density: string
        height: string
        width: string
    }
    timezone?: string
    groupId?: string
    traits?: {
        address?: {
            city: string
            country: string
            postalCode: string
            state: string
            street: string
        }
        age?: number
        avatar?: string
        company?: {
            name: string
            id: string
            industry: string
            employee_count: number
            plan: string
        }
        createdAt?: Date
        description?: string
        email?: string
        firstName?: string
        gender?: string
        id?: string
        lastName?: string
        name?: string
        phone?: string
        title?: string
        username?: string
        website?: string
        [key: string]: any
    }
    userAgent?: string
    [key: string]: any
}

type Identify = {
    (userId: string, traits?: SegmentContext['traits']): void
    (traits: SegmentContext['traits']): void
}

export const identify: Identify = (...args: any[]) => {
    window.analytics?.identify(...args)
}

export const page = (properties?: Record<string, any>) => {
    // Adding a delay ensures that the Segment route tracking is in sync with
    // the actual Gatsby route (otherwise you can end up in a state where the
    // Segment page tracking reports the previous page on route change).
    //
    // This is the same as it is done in `gatsby-plugin-segment-js` here:
    // https://github.com/benjaminhoffman/gatsby-plugin-segment-js/blob/master/src/gatsby-browser.js
    const DELAY_IN_MS = 50

    window.setTimeout(() => {
        window.analytics?.page(document.title, properties)
    }, DELAY_IN_MS)
}

export const load = (writeKey: string) => {
    window.analytics?.load(writeKey)
}
